import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import * as Bixby from '$/core';
import History from './History';


// Declare gtag used functions to satisfy ts transpiler for window
interface GtagWindow {
  gtag: (...params: any[]) => void;
  dataLayer: any[];
}

export default abstract class AnalyticsService {
  static appInsights: ApplicationInsights | undefined;

  /** This init is intentionally called after we know config has loaded successfully */
  static init = () => {
    this.appInsights = Bixby.Utils.parseBoolean(Bixby.Configuration.disableAnalytics)
      ? undefined
      : new ApplicationInsights({
          config: {
            instrumentationKey: Bixby.Configuration.applicationInsightsKey,
            disableFetchTracking: false,
            enableCorsCorrelation: true,
          },
        });

    if (this.appInsights) {
      this.appInsights.loadAppInsights();
      const trackPageView = () =>
        setTimeout(() => {
          AnalyticsService.gtagEvent('event', 'page_view');
          this.appInsights?.trackPageView({});
        }, 100);

      this.appInsights.context.application.build = Bixby.Configuration.version;
      History.listen(({ action }) => {
        if (action !== 'PUSH' && action !== 'REPLACE') {
          return;
        }

        // slight timeout to let the navigation happen first
        trackPageView();
      });

      // Log the current page view
      trackPageView();
    }
  };
  public static login(username: string) {
    AnalyticsService.gtagEvent('event', 'login');
    if (this.appInsights) {
      this.appInsights.setAuthenticatedUserContext(username);
    }
  }

  public static logout() {
    if (this.appInsights) {
      this.appInsights.clearAuthenticatedUserContext();
    }
  }
  public static event(name: string, props?: any) {
    AnalyticsService.gtagEvent('event', name, props);
    if (this.appInsights) {
      this.appInsights.trackEvent({ name }, props);
    }
  }
  public static exception(error: Error, props?: { [key: string]: any }) {
    if (this.appInsights) {
      const exceptionTelemetry: IExceptionTelemetry = {
        error,
      };

      if (props) {
        exceptionTelemetry.properties = props;
      }
      this.appInsights.trackException(exceptionTelemetry);
    }
  }

  public static gtagEvent(type: string, name: string, props?: any) {
    const gtagWindow = window as unknown as GtagWindow;
    // window.dataLayer gets added if the gtag script is enabled on index.html
    if (gtagWindow?.dataLayer) {
      gtagWindow?.gtag(type, name, props);
    }
  }
}
